export const BGcolor   = '#f8f8f8'
export const blueColor = '#007aff'
export const whiteColor = '#FFFFFF'
export const borderColor = '#bfbfbf'